module.exports = __webpack_public_path__ + "img/letter-z.6740979c.svg";